import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: "none",
      }}
      copyright="广西中满体育服务有限责任公司版权所有"
      // links={[
      //   {
      //     key: "Ant Design Pro",
      //     title: "Ant Design Pro",
      //     href: "https://pro.ant.design",
      //     blankTarget: true,
      //   },
      //   {
      //     key: "github",
      //     title: <GithubOutlined />,
      //     href: "https://github.com/ant-design/ant-design-pro",
      //     blankTarget: true,
      //   },
      //   {
      //     key: "Ant Design",
      //     title: "Ant Design",
      //     href: "https://ant.design",
      //     blankTarget: true,
      //   },
      // ]}
    />
  );
};

export default Footer;
